'use client';

import { ScrollArea, ScrollBar } from '@natu/ui/ScrollArea';
import { getSlugWithDash } from '@natu/utils/getSlugWithDash';
import { paths } from '@natu/utils/paths';

import { CategoryBarLink } from './CategoryBarLink';
import { useCategoryBar } from './getCategoryBarItems';

type DesktopCategoriesProps = {
  categoryItems: string[];
};

export const DesktopCategories = ({ categoryItems }: DesktopCategoriesProps) => {
  const { data, isEmpty } = useCategoryBar({
    categoryItems,
  });

  if (isEmpty) {
    return null;
  }

  return (
    <ScrollArea type="always" className="hidden max-w-screen-xl lg:block">
      <div className="flex w-max">
        <CategoryBarLink href={paths.blog}>All articles</CategoryBarLink>
        {data.map(category => (
          <CategoryBarLink key={category.uuid} href={getSlugWithDash(category?.fullSlug)}>
            {category.name}
          </CategoryBarLink>
        ))}
      </div>
      <ScrollBar id="scrollbar" orientation="horizontal" />
    </ScrollArea>
  );
};

export default DesktopCategories;
